import * as EventKit from 'event-kit';
export class CompositeDisposable {
    constructor() {
        this._composite = new EventKit.CompositeDisposable();
    }
    add(disposable) {
        this._composite.add(disposable);
    }
    remove(disposable) {
        this._composite.remove(disposable);
    }
    dispose() {
        return this._composite.dispose();
    }
}
//# sourceMappingURL=composite-disposable.js.map